export const environment = {
  environmentName: 'prod',
  production: true,
  baseUrl: "https://querynest.com/",
  encryptSecretKey: "r3@l@t!m3#in$!ght$k!mb3rlyh3rz0g",
  usrDetail: "iampartofknowledgeexcelteamandwearethebest",
  errorIcon: "assets/caution.png",
};
